function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { useCallback, useMemo, useRef } from 'react';
import { guid, shallowEqual } from '@bydesign-ui/utils';
import { useRefCallback, useRefGetter } from '@bydesign-ui/hooks';
export function useCascaderDatasource(value, datasource, onChange) {
  var hashMap = useRef({});
  var data = useMemo(function () {
    hashMap.current = {};
    return createDatasource(datasource, [], hashMap.current);
  }, [datasource]);
  var onChangeCallback = useRefCallback(onChange);
  var valueGetter = useRefGetter(value);
  var handleChange = useCallback(function (value) {
    var newVal = value == null ? [] : hashMap.current[value] || [];
    var ov = valueGetter();

    if (!shallowEqual(newVal, ov)) {
      onChangeCallback(newVal);
    }
  }, []);
  var newVal;
  Object.keys(hashMap.current).some(function (id) {
    if (hashMap.current[id].join(',') === value.join(',')) {
      newVal = id;
      return true;
    }
  });
  return {
    value: newVal,
    datasource: data,
    onChange: handleChange
  };
}
export function createDatasource(datasource) {
  var rootValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var hashMap = arguments.length > 2 ? arguments[2] : undefined;
  return datasource.map(function (item) {
    var values = rootValue.slice().concat(item.value);
    var id = guid();
    hashMap[id] = values;
    return _objectSpread(_objectSpread({}, item), {}, {
      value: id,
      children: createDatasource(item.children || [], values, hashMap)
    });
  });
}